<div class="row">

    <div class="col-10 offset-1" *ngIf="staticPages">

            <div *ngFor="let staticPage of staticPages">
                    <div class="row">
                    </div>
                <div class="col-12" [innerHtml]="staticPage.content">
                    
                </div>
            </div>
    </div>
</div>